<!------------------------------

Hide Proxy Element

------------------------------->

@if (!isInModalContext) {
  <div class="drag-dummy position-absolute" style="top:0; left: 0; width:100%">
  </div>

}
<!------------------------------

Page Actions

------------------------------->

<ng-container *sbPageAction>
  @if (permissionService.hasPermission(permissionService.Permission.medium_create) && permissionService.hasPermission(permissionService.Permission.medium_upload)) {
    <button
      type="button"
      sbTooltip="{{ 'lang.globals.newFile' | translate }}" container="body"
      (click)="addNewMedium()"
      [disabled]="!previewMedium && showSideBar"
      sb-button-primary
      [color]="'green'"
      [iconButton]="true"
      [icon]="'plus'"
      [loading]="loading()"
    >
    </button>
  }
  <button (click)="requestDebounced()" [disabled]="loading()"
          sb-button-primary [color]="'blue'"
          [loading]="loading()"
          type="button"
          [iconButton]="true"
          [icon]="'refresh'"
          sbTooltip="{{ 'lang.globals.refresh' | translate }}"
          container="body"
          placement="top">
  </button>
</ng-container>

@if (!isInModalContext) {
  <sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                      [sidebarTemplate]="compSidePanelTemplate" [width]="600">

  </sb-comp-side-panel>
}

<ng-template #sidebarHeader>
  <div class="tw-flex">
    @if (previewMedium) {
      <h4 [innerHTML]="previewMedium?.name | truncate : 30"></h4>
    } @else {
      <h4>{{ 'lang.globals.newFile' | translate }}</h4>
    }
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <div
    (addMediumToBooking)="addMediumToBooking($event)" (closeClick)="toggleSideBar()"
    (deleteMedium)="deleteMedium($event)"
    (dropHandler)="dropHandler($event)"
    (lockMedium)="lockMedium($event)"
    (mediumNameChanged)="onMediumNameChanged($event)"
    (openFilePicker)="openFilePicker()"
    (openFileReplacePicker)="openFileReplacePicker($event)"
    (preSelectCompany)="preSelectCompany()"
    (selectCompany)="selectCompany($event)"
    (selectTemplateGroup)="selectTemplateGroup($event)"
    (deleteTemplateGroup)="deleteTemplateGroup($event)"
    (showTemplatePreview)="showTemplatePreview($event)"
    (toggleMediumSelection)="toggleMediumSelection($event)"
    *ngIf="showSideBar"
    [@slideInOut]
    [isInModalContext]="isInModalContext"
    [modalType]="modalType"
    [preselectedCompany]="preselectedCompany"
    [previewMedium]="previewMedium"
    [resolutionOptions]="resolutionOptions"
    [selectedCompany]="selectedCompany"
    [selectedMedias]="Array.from(selectedMedias.values())"
    [selectedFolder]="selectedFolder"
    app-medium-edit>
  </div>
</ng-template>

<div (dragover)="moveDragElement($event)" class="tw-flex tw-flex-col tw-h-full md:tw-flex-row tw-gap-5">
  <!------------------------------

  Proxy Element

  ------------------------------->

  <div *ngIf="dragging" [style.left.px]="dragItemStyle.left" [style.top.px]="dragItemStyle.top"
       class="dragging-item tw-absolute tw-w-auto tw-drop-shadow" style="z-index: 70;">
    <div class="tw-relative card card-border-radius">
      <div class="card-body">
        <div class="tw-flex tw-flex-column tw-items-center">
          @if (selectedMedias.size > 1 && selectedMedias.has(dragging.id)) {
            <div class="tw-flex tw-items-center">
              <sb-icon [icon]="'motives'" [dualColor]="true" class="tw-text-5xl"></sb-icon>
              <div class=" tw-font-bold tw-text-xl tw-ml-4"> {{ selectedMedias.size }} {{ 'lang.globals.motives' | translate }}</div>
            </div>
          } @else {

            <sb-comp-image-name-wrapper [medium]="[dragging]" [still]="true">
              <span firstLine class="tw-cursor-pointer" [innerHtml]="dragging?.name|truncate:30"></span>
            </sb-comp-image-name-wrapper>
          }
        </div>
      </div>
    </div>
  </div>

  <!------------------------------

Folder

------------------------------->

  <div class="md:tw-w-1/4">
    <div
      class="tw-flex tw-drop-shadow-sm-sbGray-300 tw-flex-col tw-rounded-xl tw-w-full tw-h-full dark:tw-drop-shadow-none tw-border tw-border-solid tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-bg-sbGray-50/30 dark:tw-bg-[#2e3648]">
      <div
        class="tw-flex tw-justify-between tw-items-center tw-h-[60px] tw-px-5 tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-flex-wrap tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-rounded-t-xl">
        <div class="tw-text-lg tw-font-semibold">{{ 'lang.headlines.folder' | translate }}</div>
      </div>
      <table class="table table-hover">
        <tbody class="*:tw-cursor-pointer">
        <tr (click)="toggleFolder(null, false)" (dragleave)="dragOut($event)" (dragover)="dragOver($event, -2)"
            (drop)="drop($event, null)"
            [ngClass]="{
            '!tw-bg-sbBlue-100 *:dark:!tw-bg-sbGrayBlue-930' : !selectedFolder && !folderView && folderDragoverId !== -2,
            '!tw-bg-sbBlue-200 *:dark:!tw-bg-sbGrayBlue-800' : folderDragoverId === -2
            }"
            class="">
          <td colspan="100">
            <div class="tw-flex tw-gap-2.5">
              <sb-icon icon="folder"></sb-icon>
              <span>{{ 'lang.globals.allMotives' | translate }}</span>
            </div>
          </td>
        </tr>
        <tr (click)="toggleFolder(null)" (dragleave)="dragOut($event)" (dragover)="dragOver($event, -1)"
            (drop)="drop($event, null)"
            [ngClass]="{
            '!tw-bg-sbBlue-100 *:dark:!tw-bg-sbGrayBlue-930' : !selectedFolder && folderView && folderDragoverId !== -1,
            '!tw-bg-sbBlue-200 *:dark:!tw-bg-sbGrayBlue-800' : folderDragoverId === -1
            }"
            class="">
          <td colspan="100">
            <div class="tw-flex tw-gap-2.5">
              <sb-icon icon="folder"></sb-icon>
              <span>{{ 'lang.globals.noFolderMotives' | translate }}</span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="tw-px-5 tw-py-5 tw-border-0 tw-border-b tw-border-solid tw-flex-wrap tw-border-sbGray-500 dark:tw-border-sbGray-50">
        <div
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-group tw-w-fit tw-text-nowrap tw-flex-1 tw-mb-2 tw-gap-2.5">
          <div
            class="tw-text-lg">
            {{ 'lang.globals.ownFolder' | translate }}
          </div>
        </div>
        <sb-simple-search-bar
          #searchBar
          (submitted)="doFolderSearch($event)"
          (changed)="doFolderSearch($event)"
          [searchTerm]="folderSearch"
          [debounce]="true"
          [showExactMatch]="true"
          [exactMatch]="exactMatchFolder"
          class="tw-w-full"
        >
        </sb-simple-search-bar>

        @if (!isInModalContext) {
          <button
            class="tw-w-full tw-mt-4"
            type="button"
            (click)="toggleFolderCreation($event)"
            [disabled]="!previewMedium && showSideBar"
            sb-button-secondary
            [color]="'green'"
            [icon]="'plus'"
            [loading]="loading()"
          >
            {{ 'lang.globals.createFolder' | translate }}
          </button>
        }
      </div>
      @if (!isInModalContext) {

        <div
          class="tw-overflow-hidden tw-w-full tw-bg-sbGray-100 tw-p-2 dark:tw-bg-sbGray-800 tw-transition-all tw-ease-in-out tw-duration-300"
          [ngClass]="{
                  'tw-h-12': folderCreationMode,
                  'tw-h-0 tw-py-0': !folderCreationMode
                  }"
        >
          <div class="tw-flex tw-items-center tw-gap-3">
            <input #folderInput [(ngModel)]="folderName" class="tw-input tw-w-full"
                   placeholder="{{'lang.globals.folderName' | translate}}"
                   type="text" />
            <button
              type="button"
              sb-button-primary
              [color]="'green'"
              [iconButton]="true"
              [icon]="'checked'"
              (click)="createNewFolder()" [disabled]="!folderName || folderCreationInProgress"
            >
            </button>
            <button
              type="button"
              sb-button-primary
              [color]="'red'"
              [iconButton]="true"
              [icon]="'cancel'"
              (click)="toggleFolderCreation($event)"
            >
            </button>
          </div>
        </div>
      }
      <div class="tw-max-h-[800px] tw-overflow-y-auto custom-scrollbar tw-w-full">
        <table class="table table-hover tw-mb-3">
          <tbody class="*:tw-cursor-pointer">
            @for (folder of mediumFolders; track folder.id) {

              <tr (click)="toggleFolder(folder)" (dragleave)="dragOut($event)" (dragover)="dragOver($event, folder?.id)"
                  (drop)="drop($event, folder)"
                  [ngClass]="{
                  '!tw-bg-sbBlue-100 *:dark:!tw-bg-sbGrayBlue-930' : folder.id === selectedFolder?.id,
                  '!tw-bg-sbBlue-200 *:dark:!tw-bg-sbGrayBlue-800' : folderDragoverId === folder.id
                  }"
                  class="*:!tw-border-0">
                <td>
                  <div class="tw-flex tw-gap-2.5">
                    <sb-icon icon="folder"></sb-icon>
                    <span [innerHTML]="folder.name | truncate : 20"></span>
                  </div>
                </td>
                <td>
                  <div class="tw-flex tw-gap-2.5">
                    <sb-icon icon="motives"></sb-icon>
                    <!--
                    <div
                      class="tw-flex tw-w-fit tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-1 tw-px-3"
                      sbTooltip="{{util.formatBytes(folder.folderSize)}}"
                    >
                    -->
                    <div>
                      {{ folder.elementsCount }}
                    </div>
                  </div>
                </td>
                <td class="text-right">
                  @if (!isInModalContext) {
                    <sb-icon (click)="deleteFolder($event, folder)" class="red" icon="trash"></sb-icon>
                  }
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="100">
                  @if (folderSearch) {
                    <i class="tw-font-light"> - {{ 'lang.globals.noFolderFound' |translate }} - </i>
                  } @else {
                    <i class="tw-font-light"> - {{ 'lang.globals.noOwnFolder' |translate }} - </i>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!------------------------------

         Media

   ------------------------------->

  <div class="md:tw-w-3/4">
    @if (!isInModalContext) {
      <sb-comp-uploading-element>
      </sb-comp-uploading-element>
    }
    @let isExpanded = checkExpansion();
    @let ordering = orderOption();
    <sb-table-wrapper-new [itemName]="'media'" [itemsData]="medias" [loading]="loading()"
                          [isInModalContext]="isInModalContext"
                          headline="{{'lang.headlines.motives' | translate}}"
                          (paginationChange)="requestDebounced($event)"
                          class="tw-w-full"
                          [isSplitscreen]="true"
                          [isFilterPanelOpen]="isExpanded"
                          [isMultiSelectEnabled]="selectedMedias?.size >0"
    >

      <!------------------------------

    Filter

  ------------------------------->
      <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
        <sb-filter-panel
          #FilterPanelRef
          (filterChange)="applyFiltering($event)"
          [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
          [config]="filterConfig"
          filterID="search"
        >

          <sb-filter-section
            title="{{'lang.globals.filterAttributes' |translate}}" icon="toggleOn"
            classes="tw-flex tw-flex-col tw-gap-2">
            <sb-filter-threeway-toggle filterID="locked" [default]="null"
                                       [label]="'lang.attributeToggles.medium.locked' | translate"></sb-filter-threeway-toggle>
            <sb-filter-threeway-toggle filterID="mediumGroupSet" [default]="null"
                                       [label]="'lang.attributeToggles.medium.mediumGroupSet' | translate"></sb-filter-threeway-toggle>
          </sb-filter-section>
          <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                             icon="company">
            <sb-filter-dto-list-select filterID="companies" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
            </sb-filter-dto-list-select>
          </sb-filter-section>
          <sb-filter-section *ngPermissions="permissionService.Permission.medium_show" title="{{'lang.globals.resolution' | translate}}"
                             icon="resolution">
            <sb-filter-dto-list-select filterID="resolution" [isSingleSelect]="true"
                                       [disabled]="resolutionDisabled" [defaultValues]="resolutionDisabled? [resolution] : []"
                                       [disableUnselect]="resolutionDisabled"
                                       [endpoint]="api.mm_Medium_retrieveAllResolutions.bind(api)">
            </sb-filter-dto-list-select>
          </sb-filter-section>


          <hr>
          <div class="tw-mx-3 tw-gap-2.5 tw-flex tw-flex-col tw-mb-4">
            <div
              #filterPanelOrder
              class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit"
              [ngClass]="{'tw-cursor-pointer': !isExpanded}"
              (click)="!isExpanded?openFilterPanel(filterPanelOrder):scrollToFilterPanelElement(filterPanelOrder)">
              <sb-icon class="" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                       icon="sort"></sb-icon>
              <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
                   [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.order' | translate }}
              </div>
            </div>
            <div class="tw-flex tw-flex-grow tw-gap-2.5">

              @let fpOrderOption = filterPanelOrderOption();
              <sb-button-dropdown
                [selectedValue]="fpOrderOption.value" [items]="allOrderOptions|omit: 'direction'"
                (outputChange)="setToOrderFilterPanel($event)"
                [openDirection]="'Up'"
                class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left"
                [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
              >
              </sb-button-dropdown>
              <sb-segment-control
                [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
                [selectedOption]="{value: fpOrderOption.direction}"
                [options]="[{value: 'asc', icon: 'sortUpFilled' },{value: 'desc', icon: 'sortDownFilled' }]"
                (selectedOptionChange)="setOrderDirectionFilterPanel($event.value)"
              ></sb-segment-control>
            </div>
          </div>
        </sb-filter-panel>
      </div>

      <!------------------------------

         Table Header

   ------------------------------->
      <ng-template #thead>
        <tr>
          @if (!isInModalContext) {
            <th>
              <sb-icon icon="drag"></sb-icon>
            </th>
          }
          @if (!isInModalContext || isInModalContext && modalType === 'groupSelect') {
            <th
              [ngClass]="{'sticky-col first-col': isInModalContext && modalType === 'groupSelect' }"
            >
              <sb-comp-table-multi-select-button [selectionState]="selectionState"
                                                 (action)="selectAction($event)"></sb-comp-table-multi-select-button>
            </th>
          }
          @if (!folderView && !selectedFolder) {
            <th>{{ 'lang.headlines.folder' | translate }}</th>
          }
          <th>Status</th>
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_Medium_retrieveAll_order.NAME)"
              [ngClass]="{'table--sorted': ordering?.value===mm_Medium_retrieveAll_order.NAME}">
            {{ 'lang.globals.name' | translate }}
            @if (ordering.value === mm_Medium_retrieveAll_order.NAME) {
              <sb-icon
                *ngIf="ordering.direction === 'desc'"
                icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              <sb-icon
                *ngIf="ordering.direction !== 'desc'"
                icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th>
            {{ 'lang.globals.company'|translate }}
          </th>
          <th>
            {{ 'lang.globals.resolution'|translate }}
          </th>
          <th class="table--sortable"
              (click)="setToOrderAndRefresh(mm_Medium_retrieveAll_order.DURATION)"
              [ngClass]="{'table--sorted': ordering?.value=== mm_Medium_retrieveAll_order.DURATION}">
            {{ 'lang.globals.duration' | translate }}
            @if (ordering.value === mm_Medium_retrieveAll_order.DURATION) {
              <sb-icon
                *ngIf="ordering.direction === 'desc'"
                icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              <sb-icon
                *ngIf="ordering.direction !== 'desc'"
                icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th>
            {{ 'lang.globals.group'|translate }}
          </th>
          <th>
            {{ 'lang.globals.products'|translate }}
          </th>
          <th>
            {{ 'lang.globals.file'|translate }}
          </th>
          <th class="table--sortable"
              (click)="setToOrderAndRefresh(mm_Medium_retrieveAll_order.CREATED_AT)"
              [ngClass]="{'table--sorted': ordering?.value===mm_Medium_retrieveAll_order.CREATED_AT}">
            {{ 'lang.globals.modifiedAt' | translate }}
            @if (ordering.value === mm_Medium_retrieveAll_order.CREATED_AT) {
              <sb-icon
                *ngIf="ordering.direction === 'desc'"
                icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              <sb-icon
                *ngIf="ordering.direction !== 'desc'"
                icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          @if (!isInModalContext || (isInModalContext && modalType !== "groupSelect")) {
            <th class="sticky-col last-col">
              {{ 'lang.globals.action' |translate }}
            </th>
          }
        </tr>
      </ng-template>

      <ng-template #tCardHead>
        <tr>
          @if (!isInModalContext || isInModalContext && modalType === 'groupSelect') {
            <th
              [ngClass]="{'sticky-col first-col': isInModalContext && modalType === 'groupSelect' }">
              <sb-comp-table-multi-select-button [selectionState]="selectionState"
                                                 (action)="selectAction($event)"></sb-comp-table-multi-select-button>
            </th>
          }
          <th class="table--sortable" (click)="setToOrderAndRefresh(mm_Medium_retrieveAll_order.NAME)"
              [ngClass]="{'table--sorted': ordering?.value===mm_Medium_retrieveAll_order.NAME}">
            {{ 'lang.globals.name' | translate }}
            @if (ordering.value === mm_Medium_retrieveAll_order.NAME) {
              <sb-icon
                *ngIf="ordering.direction === 'desc'"
                icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              <sb-icon
                *ngIf="ordering.direction !== 'desc'"
                icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable"
              (click)="setToOrderAndRefresh(mm_Medium_retrieveAll_order.DURATION)"
              [ngClass]="{'table--sorted': ordering?.value===mm_Medium_retrieveAll_order.DURATION}">
            {{ 'lang.globals.duration' | translate }}
            @if (ordering.value === mm_Medium_retrieveAll_order.DURATION) {
              <sb-icon
                *ngIf="ordering.direction === 'desc'"
                icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              <sb-icon
                *ngIf="ordering.direction !== 'desc'"
                icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>
          <th class="table--sortable"
              (click)="setToOrderAndRefresh(mm_Medium_retrieveAll_order.CREATED_AT)"
              [ngClass]="{'table--sorted': ordering?.value===mm_Medium_retrieveAll_order.CREATED_AT}">
            {{ 'lang.globals.modifiedAt' | translate }}
            @if (ordering.value === mm_Medium_retrieveAll_order.CREATED_AT) {
              <sb-icon
                *ngIf="ordering.direction === 'desc'"
                icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
              <sb-icon
                *ngIf="ordering.direction !== 'desc'"
                icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
          </th>

          <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
        </tr>
      </ng-template>

      <!------------------------------

      SelectionMode

  ------------------------------->
      <ng-template #tSelectionMode>
        <sb-action-bar [isInModalContext]="isInModalContext">
          <!-- projected info -->
          <div info>
            {{ selectedMedias.size }} {{ 'lang.globals.selected' | translate }}
          </div>

          <!-- deselect button -->
          <button
            deselect
            type="button"
            sb-button-secondary
            [color]="'blue'"
            class="tw-text-nowrap"
            (click)="selectAction('deselectAll')">
            {{ 'lang.multiSelect.deselectAll'|translate }}
          </button>

          <!-- actions -->
          <button actions sb-button-primary type="button" [color]="'blue'" [icon]="'motives'" (click)="toMediumGroup()"
                  class="tw-text-nowrap"
                  [disabled]="!isEqualCompanyForSelected()">
            {{ 'lang.mediumGroups.createMotiveGroup'|translate }}
          </button>
          <button actions sb-button-primary type="button" [color]="'blue'" [icon]="'companySwitch'" (click)="changeCompany()"
                  class="tw-text-nowrap"
                  [disabled]="!isLockedMediumInSelected() || hasMediumInMediumGroup()">
            {{ 'lang.globals.switchCompany'|translate }}
          </button>
          <button actions sb-button-primary type="button" [color]="'green'" [icon]="'lockClosed'" (click)="setReady()"
                  class="tw-text-nowrap"
          >
            {{ 'lang.mediumExplorer.setReady'|translate }}
          </button>
          <button actions sb-button-primary type="button" [color]="'red'" [icon]="'trash'" (click)="deleteMultiple()"
                  class="tw-text-nowrap">
            {{ 'lang.globals.delete' | translate }}
          </button>

        </sb-action-bar>

      </ng-template>

      <!------------------------------

        Table Body

    ------------------------------->
      <!--
      <ng-template #singleRow>
        <tr sb-comp-medium-upload>
        </tr>
      </ng-template>
      -->
      <ng-template #tbody let-medium>
        <tr
          [ngClass]="{'medium-excluded' : medium['excluded'] || (!medium.locked && isInModalContext), 'tw-bg-sbBlue-50 *:dark:!tw-bg-sbGrayBlue-930': selectedMedias.has(medium.id)}"
        >
          @if (!medium.id) {
            <td colspan="100">
              <div class="tw-flex tw-items-center tw-text-[4rem]">
                <div class="tw-mr-4 tw-w-20">
                  <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="uploadAltAnimation"></sb-icon>
                </div>
                <h5 class="tw-font-bold tw-m-0">
                  {{ 'lang.globals.uploadFiles' | translate }}...
                </h5>
              </div>
            </td>
            <td colspan="100">
              <div class="tw-flex tw-items-center tw-text-[4rem]">
                <div class="tw-mr-3 tw-w-20">
                  <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="linkAnimation"></sb-icon>
                </div>
                <h5 class="tw-font-bold tw-m-0">
                  {{ 'lang.globals.processing' | translate }}...
                </h5>
              </div>
            </td>
          } @else {
            @if (!isInModalContext) {
              <td class="tw-w-0 tw-no-wrap">
                <button sb-button-primary type="button" [color]="'blue'" [iconButton]="true" [icon]="'drag'" (dragend)="dragEnd()"
                        (dragstart)="dragStart({event: $event, item: medium})"
                        [draggable]="medium?.id">
                </button>
              </td>
            }
            @if (!isInModalContext || isInModalContext && modalType === 'groupSelect') {
              <td
                [ngClass]="{'sticky-col first-col': isInModalContext && modalType === 'groupSelect' }"
              >
                <ng-container [ngTemplateOutlet]="SelectMedium" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>
              </td>
            }
            @if (!folderView && !selectedFolder) {
              <td class="">
                <div class="tw-flex tw-gap-1">
                  <sb-icon icon="folder" class="tw-mr-1"></sb-icon>
                  <div [innerHTML]="(medium?.folder?.name ?? '-') | truncate:15"></div>
                </div>
              </td>
            }
            <td>
              <ng-container [ngTemplateOutlet]="LockedState" [ngTemplateOutletContext]="{$implicit: medium, inline: false}"></ng-container>
            </td>
            <td>
              <sb-comp-image-name-wrapper [medium]="[medium]" [still]="true">
                <span firstLine class="tw-cursor-pointer" (click)="!isInModalContext?mediumToPreview(medium):''"
                      [innerHtml]="medium?.name|truncate:30"></span>
                <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="medium?.id"
                         [dtoType]="tagService.TaggableDTO.Medium"
                         [tags]="medium?.tags" fourthLine></sb-tags>
              </sb-comp-image-name-wrapper>
            </td>
            <td>
              <div class="tw-flex tw-gap-1">
                <sb-icon icon="company"></sb-icon>
                <div [innerHTML]="(medium?.company?.name ?? ('lang.globals.unknown' | translate)) | truncate : 20"></div>
              </div>

            </td>
            <td>
              <ng-container [ngTemplateOutlet]="ResolutionDisplay" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>

            </td>
            <td>
              <sb-icon icon="clock"></sb-icon>
              {{ medium?.duration ? medium?.duration + 's' : '-' }}
            </td>

            <td>
              <div class="tw-flex tw-flex-col tw-gap-1">
                <div class="tw-flex tw-gap-1">
                  <sb-icon icon="motives"></sb-icon>
                  <sb-comp-link
                    [title]="medium?.mediumGroup?.name ?? '-' | truncate : 25"
                    [permission]="permissionService.Permission.medium_group_show"
                    [condition]="!isInModalContext && medium?.mediumGroup?.id"
                    [link]="util.RoutingID.mediumGroupEdit"
                    [pathParams]="[{id: 'mediumGroupID', value: medium?.mediumGroup?.id}]"
                    [tooltip]="'lang.mediumExplorer.switchMediumgroup' | translate">
                  </sb-comp-link>
                </div>
                <div class="tw-flex tw-gap-1">
                  <sb-icon icon="templates"></sb-icon>
                  <div [innerHTML]="medium?.templateGroup?.name ?? '-' | truncate : 25"></div>
                </div>
              </div>
            </td>
            <td>
              <ng-container [ngTemplateOutlet]="PromotedProducts" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>

            </td>
            <td>
              <ng-container [ngTemplateOutlet]="ContentType" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>

              <div>
                <sb-icon icon="file"></sb-icon>
                {{ util.formatBytes(medium?.size) }}
              </div>
            </td>
            <td>
              <sb-comp-display-created [data]="medium"></sb-comp-display-created>
            </td>
            @if (!isInModalContext || (isInModalContext && modalType !== "groupSelect")) {
              <td class="sticky-col last-col">
                <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>
              </td>
            }
          }
        </tr>
      </ng-template>

      <!------------------------------

       Card Element

   ------------------------------->
      <ng-template #card let-medium>
        <sb-table-card
          class="tw-rounded-xl"
          [ngClass]="{'medium-excluded' : medium['excluded'] || (!medium.locked && isInModalContext), 'tw-bg-sbBlue-50 *:dark:!tw-bg-sbGrayBlue-930': selectedMedias.has(medium.id)}"
        >
          <div table-card-header class="tw-flex tw-gap-3">
            <ng-container [ngTemplateOutlet]="SelectMedium" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>
          </div>

          <div table-card-header-more>
            <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: medium}"></ng-container>
          </div>
          <div table-card-img>
            <sb-comp-medium [medium]="medium" [customHeight]="'240px'" [customWidth]="'100%'" [thumbnailSize]="'M'"
                            [still]="true" (click)="mediumToPreview(medium)"></sb-comp-medium>
          </div>
          <div table-card-sub-header>
            <button sb-button-primary type="button" [color]="'blue'" [iconButton]="true" [icon]="'drag'" (dragend)="dragEnd()"
                    (dragstart)="dragStart({event: $event, item: medium})"
                    [draggable]="medium?.id">
            </button>
          </div>
          <div table-card-body>
            <div
              class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:tw-py-3.5 *:sm:tw-py-5">
              <sb-table-card-element
                class="!tw-col-span-4"
                [orientation]="'left'" [headline]="'lang.globals.medium' | translate">
                <sb-comp-name-wrapper>
                  <span firstLine class="tw-cursor-pointer" (click)="!isInModalContext?mediumToPreview(medium):''"
                        [innerHtml]="medium?.name|truncate:30"></span>
                  <div secondLine>
                    <ng-container [ngTemplateOutlet]="LockedState"
                                  [ngTemplateOutletContext]="{$implicit: medium, inline:true}"></ng-container>
                  </div>
                  <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="medium?.id"
                           [dtoType]="tagService.TaggableDTO.Medium"
                           [tags]="medium?.tags" fourthLine></sb-tags>
                </sb-comp-name-wrapper>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.headlines.folder' | translate " [orientation]="'left'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="folder"></sb-icon>
                <span [innerHTML]="(medium?.folder?.name ?? '-' ) | truncate : 15"></span>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.customer' | translate " [orientation]="'right'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="company"></sb-icon>
                <span [innerHTML]="(medium?.company?.name ?? ('lang.globals.unknown' | translate)) | truncate : 20"></span>
              </sb-table-card-element>

              <sb-table-card-element class="" [headline]="'lang.globals.resolution' | translate " [orientation]="'left'">
                <ng-container [ngTemplateOutlet]="ResolutionDisplay"
                              [ngTemplateOutletContext]="{$implicit: medium, orientation: 'left'}"></ng-container>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.duration' | translate " [orientation]="'right'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="clock"></sb-icon>
                <span [innerHTML]="medium?.duration ? medium?.duration + 's' : '-'"></span>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.mediumGroup' | translate"
                                     [orientation]="'left'" [classes]="'tw-gap-2'">
                <sb-icon class="mr-1" icon="motives"></sb-icon>
                <div>
                  <sb-comp-link
                    [title]="medium?.mediumGroup?.name ?? '-' | truncate : 12"
                    [permission]="permissionService.Permission.medium_group_show"
                    [condition]="!isInModalContext && medium?.mediumGroup?.id"
                    [link]="util.RoutingID.mediumGroupEdit"
                    [pathParams]="[{id: 'mediumGroupID', value: medium?.mediumGroup?.id}]"
                    [tooltip]="'lang.mediumExplorer.switchMediumgroup' | translate">
                  </sb-comp-link>
                </div>
              </sb-table-card-element>
              <sb-table-card-element class="" [headline]="'lang.globals.templateGroup' | translate " [orientation]="'right'"
                                     [classes]="'tw-gap-2'">
                <sb-icon icon="templates"></sb-icon>
                <span [innerHTML]="medium?.templateGroup?.name ?? '-' | truncate: 12"></span>
              </sb-table-card-element>


              <sb-table-card-element class="" [headline]="'lang.globals.contentType' | translate " [orientation]="'left'">
                <ng-container [ngTemplateOutlet]="ContentType"
                              [ngTemplateOutletContext]="{$implicit: medium, orientation: 'left'}"></ng-container>
              </sb-table-card-element>


              <sb-table-card-element [classes]="'tw-gap-2'" [headline]=" 'lang.globals.filesize' | translate " [orientation]="'right'">
                <sb-icon icon="file"></sb-icon>
                <span [innerHTML]="util.formatBytes(medium?.size)"></span>
              </sb-table-card-element>

              <sb-table-card-element class="!tw-border-0" [headline]="'lang.globals.products' | translate"
                                     [orientation]="'left'">
                <ng-container [ngTemplateOutlet]="PromotedProducts"
                              [ngTemplateOutletContext]="{$implicit: medium, orientation: 'left'}"></ng-container>
              </sb-table-card-element>

              <sb-table-card-element class="!tw-border-0" [headline]="'lang.globals.modifiedAt' | translate"
                                     [orientation]="'right'">
                <sb-comp-display-created [data]="medium" [reverse]="true"></sb-comp-display-created>
              </sb-table-card-element>
            </div>
          </div>
        </sb-table-card>
      </ng-template>

    </sb-table-wrapper-new>

  </div>
</div>
@if (isInModalContext && modalType === 'groupSelect') {
  <div slot="footer" class="tw-flex tw-justify-between tw-mt-6">
    <div>
      <button type="button" color="red" (click)="dismissModal()"
              sb-button-primary>{{ 'lang.globals.cancel' | translate }}
      </button>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2.5">
      <div class="tw-flex tw-items-center">
        {{ selectedMedias?.size }} {{ 'lang.mediumExplorer.motivesSelected' | translate }}
      </div>
      <div class="">
        <button sb-button-primary color="blue" (click)="returnMediumsToModal()" [disabled]="selectedMedias?.size < 1"
                classes="btn-primary btn-sm" [type]="'submit'">{{ 'lang.globals.apply' | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (!isInModalContext) {

  <input #filePicker (change)="filePicked()" multiple style="display:none;" type="file">

  <input #fileReplacePicker (change)="replacementFilePicked()" single style="display:none;" type="file">

}
<ng-template #ActionButtons let-item>
  <div class="tw-flex tw-gap-2.5">
    @if (isInModalContext) {
      @if (item.locked) {
        @if (modalType !== 'groupSelect') {
          <button (click)="addMediumToBooking(item)"
                  sb-button-secondary
                  type="button"
                  [color]="'blue'"
                  [iconButton]="true">
            <sb-icon icon="boxChecked"></sb-icon>
          </button>
        }
      }
    } @else {
      <!-- not in modal -->

      <sb-split-button
        [splitButtonItems]="item?.sbButtons ?? []"
        (selectedAction)="resolveSplitButtonAction(item, $event)"
      ></sb-split-button>
    }

  </div>
</ng-template>

<ng-template #SelectMedium let-item>
  @let isMediumSelected = selectedMedias.has(item?.id) ?? false;
  <sb-comp-table-select-button [isSelected]="isMediumSelected"
                               [disabled]="item['excluded']"
                               (action)="toggleMediumSelection(item)"></sb-comp-table-select-button>
</ng-template>

<ng-template #LockedState let-medium let-inline="inline">

  <div class="tw-flex tw-justify-center tw-items-center tw-rounded-full tw-p-2 tw-w-fit dark:tw-text-white"
       [ngClass]=" {
     'tw-bg-sbRed-50 tw-text-sbRed-500 dark:tw-bg-sbRed-800': !medium.locked,
     'tw-bg-sbOrange-50 tw-text-sbOrange-500 dark:tw-bg-sbOrange-800': medium.locked && medium.usageCount <1,
     'tw-bg-sbGreen-50 tw-text-sbGreen-500 dark:tw-bg-sbGreen-800': medium.locked && medium.usageCount >=1,
     'tw-px-4' : inline
     }"
       container="body" [sbTooltip]="!inline? hoverReason : ''" placement="right">
    <div class="tw-size-2 tw-rounded-full"
         [ngClass]=" {
     'tw-bg-sbRed-500': !medium.locked,
     'tw-bg-sbOrange-500': medium.locked && medium.usageCount <1,
     'tw-bg-sbGreen-500': medium.locked && medium.usageCount >=1,

     }"
    ></div>
    @if (inline) {
      <div class="tw-ml-2">
        <ng-container [ngTemplateOutlet]="hoverReason"></ng-container>
      </div>
    }
  </div>
  <ng-template #hoverReason>
    @if (!medium.uploading && !medium.processing) {
      @if (!medium?.locked) {
        {{ 'lang.mediumExplorer.notReadyUse' |translate }}
      } @else {
        @if (medium.usageCount >= 1) {
          {{ 'lang.mediumExplorer.inUse' | translate }}
        } @else {
          {{ 'lang.mediumExplorer.readyUse' | translate }}
        }
      }
    }

  </ng-template>
</ng-template>


<ng-template #ResolutionDisplay let-medium let-orientation="orientation">
  @let displayNoMatching = displayNoMatchingMarker(medium);
  <div [class.red]="displayNoMatching" class="tw-flex tw-flex-row tw-gap-2"
       [ngClass]="{ 'md:tw-flex-row-reverse': orientation === 'right'}"
       [ngbTooltip]="displayNoMatching? ('lang.globals.noMatchingResolution' | translate) : null">
    <sb-icon icon="marker"></sb-icon>
    <div>{{ medium?.resolution?.id ?? '-' }}</div>
    @if (displayNoMatching) {
      <sb-icon icon="attention"></sb-icon>
    }
  </div>
</ng-template>

<ng-template #ContentType let-medium let-orientation="orientation">
  <div class="tw-flex tw-flex-row tw-gap-2"
       [ngClass]="{ 'md:tw-flex-row-reverse': orientation === 'right'}">
    @if (medium?.contentType) {
      @if (medium?.contentType.indexOf('video') !== -1) {
        <sb-icon icon="video"></sb-icon>
      } @else if (medium?.contentType.indexOf('image') !== -1) {
        <sb-icon
          icon="photo"></sb-icon>
      } @else {
        <sb-icon icon="brackets"></sb-icon>
      }
      <span class="" [innerHTML]="medium?.contentType | truncate : 15"></span>
    }
  </div>
</ng-template>

<ng-template #PromotedProducts let-medium let-orientation="orientation">
  @let productCount = medium?.promotedProducts?.length ?? 0;
  <span class="tw-flex tw-flex-row tw-gap-2" style="white-space: nowrap;" [ngbTooltip]="allProducts" container="body"
        [ngClass]="{ 'md:tw-flex-row-reverse': orientation === 'right'}"
  >
      <sb-icon icon="product"></sb-icon>
      <span [innerHTML]="productCount >= 1 ? ((productCount=== 1 ?
        (medium?.promotedProducts[0]?.name)
        :productCount +' '+ ('lang.globals.products' | translate)) | truncate : 15)
        :'-'"
            [ngClass]="{'tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-2 tw-px-4' : productCount>1}"
      >
      </span>
    </span>
  <ng-template #allProducts>
    <table class="table table-borderless">
      @if (medium?.promotedProducts?.length > 0) {
        @for (element of medium.promotedProducts; track $index) {

          <tr>
            <td class="tw-text-start" [innerHTML]="element?.name | truncate : 25"></td>
          </tr>
        }
      } @else {
        <tr>
          <td class="tw-text-start" [innerHTML]="('lang.globals.noProducts' | translate) | truncate : 25"></td>
        </tr>

      }
    </table>
  </ng-template>
</ng-template>
